export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Transportation.4d4609e0.PNG";